import React from 'react'
import createSvgIcon from './createSvgIcon'

export default createSvgIcon(
  <path d="M20.3 8.3C19.2 4.6 15.9 2 12 2 8.1 2 4.8 4.6 3.7 8.3 2.7 8.8 2 9.8 2 11v3c0 1.7 1.3 3 3 3h3c.6 0 1-.4 1-1V9c0-.6-.4-1-1-1H6c1-2.4 3.4-4 6-4 2.7 0 5 1.6 6 4h-2c-.6 0-1 .4-1 1v7c0 .6.4 1 1 1h1.8c-.4 1.2-1.5 2-2.8 2h-1.3c-.3-.6-1-1-1.7-1-1.1 0-2 .9-2 2s.9 2 2 2c.7 0 1.4-.4 1.7-1H15c2.5 0 4.5-1.8 4.9-4.2 1.2-.4 2.1-1.5 2.1-2.8v-3c0-1.2-.7-2.2-1.7-2.7zM7 15H5c-.6 0-1-.4-1-1v-3c0-.6.4-1 1-1h2v5zm13-1c0 .6-.4 1-1 1h-2v-5h2c.6 0 1 .4 1 1v3z" />,
  'CallCenter'
)
